import React, {FC} from 'react';

import {Button} from '@macmillanplatform/ui-core';
import {Callback} from '@macmillanplatform/ui-core/types';

import './index.css';

interface SnapButtonProps {
  isDisabled?: boolean;
  onClickFunc: Callback;
  isLoading?: boolean;
  iconImage: string;
  btnText: string;
  outlined?: boolean;
}

const SnapButton: FC<SnapButtonProps> = props => {
  const {isDisabled, onClickFunc, isLoading, iconImage, btnText, outlined} =
    props;
  return (
    <Button
      disabled={isDisabled}
      className="SnapButton"
      onClick={onClickFunc}
      outlined={outlined}
    >
      {isLoading ? (
        <i className="fa-duotone fa-spinner-scale fa-spin"></i>
      ) : (
        <>
          <img src={iconImage} alt="folio icon" /> {btnText}
        </>
      )}
    </Button>
  );
};

export default SnapButton;
